"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactivateLoader = void 0;
const sessionRepository_1 = require("../../../repositories/sessionRepository");
const userRepository_1 = __importDefault(require("../../../repositories/userRepository"));
const reactivateLoader = async () => {
    try {
        const user = await userRepository_1.default.getUser();
        if (user) {
            try {
                return sessionRepository_1.SessionRepository.logout();
            }
            catch {
                return true;
            }
        }
        return true;
    }
    catch {
        return true;
    }
};
exports.reactivateLoader = reactivateLoader;
